/**
 * Network Coverage - Modal Functionality
 */
(function() {
  'use strict';
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    initModal();
  }
  
  function initModal() {
    const modal = document.getElementById('countriesModal');
    const modalTrigger = document.querySelector('[data-modal-trigger]');
    const modalClose = document.querySelector('.coverage-modal-close');
    const modalCloseFloating = document.querySelector('.coverage-modal-close-floating');
    const modalOverlay = document.querySelector('.coverage-modal-overlay');
    const modalHeader = document.querySelector('.coverage-modal-header');
    
    if (!modal || !modalTrigger) return;
    
    let scrollPosition = 0;
    
    // Open modal
    modalTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      openModal();
    });
    
    // Close: Desktop X-Button (im Header)
    if (modalClose) {
      modalClose.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
    }
    
    // Close: Mobile Floating Button
    if (modalCloseFloating) {
      modalCloseFloating.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
    }
    
    // Close: Overlay
    if (modalOverlay) {
      modalOverlay.addEventListener('click', function() {
        closeModal();
      });
    }
    
    // Close: Gesamter Header ist klickbar
    if (modalHeader) {
      modalHeader.addEventListener('click', function(e) {
        if (e.target === modalHeader || e.target.closest('.coverage-modal-close')) {
          closeModal();
        }
      });
    }
    
    // Close: Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.style.display === 'flex') {
        closeModal();
      }
    });
    
    // Mobile: Swipe down to close
    let startY = 0;
    let currentY = 0;
    const modalContent = document.querySelector('.coverage-modal-content');
    
    if (modalHeader && modalContent) {
      modalHeader.addEventListener('touchstart', function(e) {
        startY = e.touches[0].clientY;
      }, { passive: true });
      
      modalHeader.addEventListener('touchmove', function(e) {
        currentY = e.touches[0].clientY;
        const diff = currentY - startY;
        
        if (diff > 0) {
          modalContent.style.transform = 'translateY(' + diff + 'px)';
        }
      }, { passive: true });
      
      modalHeader.addEventListener('touchend', function() {
        const diff = currentY - startY;
        
        if (diff > 100) {
          closeModal();
        }
        
        modalContent.style.transform = '';
      });
    }
    
    function openModal() {
      scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      modal.style.display = 'flex';
      document.body.classList.add('modal-open');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollPosition + 'px';
      document.body.style.width = '100%';
    }
    
    function closeModal() {
      modal.style.display = 'none';
      document.body.classList.remove('modal-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollPosition);
    }
  }
})();